<template>
  <div>
    <v-card v-if="!isCard">
      <v-card-title>
        {{ formTitle }}
        <v-spacer />
        <v-btn
          color="white"
          depressed
          small
          fab
          @click="
          editItem ? cancelEdit() : deleteItem ? cancelDel() : cancelNew()
        "
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form v-model="valid">
          <v-select
            v-model="items.broker"
            :items="brokers"
            item-text="name"
            item-value="code"
            label="Broker"
            required
            :disabled="deleteItem ? true : false"
          ></v-select>

          <v-text-field
            v-model="items.name"
            label="Name"
            required
            clearable
            :rules="[v => !!v && v.length <= nameLength || 'Name must less than max characters']"
            :counter="nameLength"
            :disabled="deleteItem ? true : false"
          ></v-text-field>

          <v-text-field
            v-model="items.loginId"
            label="Login ID"
            required
            clearable
            :rules="loginIdRules"
            :disabled="deleteItem ? true : false"
          ></v-text-field>
          <v-text-field
            v-model="items.token"
            label="Token"
            clearable
            :disabled="deleteItem ? true : false"
          ></v-text-field>
          <v-select
            v-model="items.strategyId"
            :items="Object.values(strategies)"
            item-text="name"
            item-value="id"
            label="Strategy"
            required
            :disabled="deleteItem ? true : false"
          ></v-select>
          <v-textarea
            v-model="items.description"
            label="Description in max 200 characters"
            auto-grow
            outlined
            rows="3"
            row-height="25"
            shaped
            counter="200"
          ></v-textarea>
          <v-row justify="space-between">
            <v-switch
              v-model="items.live"
              class="ma-4"
              label="Live"
              :disabled="deleteItem ? true : false"
            ></v-switch>
            <v-switch
              v-model="items.enable"
              class="ma-4"
              label="Enable"
              :disabled="deleteItem ? true : false"
            ></v-switch>
          </v-row>
          <v-row justify="space-between">
            <v-switch
              v-model="items.invisible"
              class="ma-4"
              label="Invisible"
              :disabled="deleteItem ? true : false"
            ></v-switch>
            <v-switch
              v-model="items.allowSubscribe"
              class="ma-4"
              label="Allow Subscribe"
              :disabled="deleteItem ? true : false"
            ></v-switch>
          </v-row>
          <v-checkbox
            v-model="agree"
            :rules="[v => !!v || 'You must agree to continue!']"
            label="Are you sure?"
            required
          ></v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="editItem">
        <v-btn outlined color="primary" text block :disabled="!valid" @click="onEdit">UPDATE</v-btn>
      </v-card-actions>
      <v-card-actions v-else-if="deleteItem">
        <v-btn outlined color="primary" text block :disabled="!valid" @click="onDelete">DELETE</v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn
          outlined
          color="primary"
          text
          block
          :disabled="!valid"
          @click="onCreate(newItem)"
        >CREATE</v-btn>
      </v-card-actions>
    </v-card>
    <Card v-else :item="itemOfCard"></Card>
  </div>
</template>
<script>
import { ACCOUNT, STRATEGY, ERROR } from "@/store/actions.type";
import { mapGetters } from "vuex";
import Card from "@/components/accounts/Card.vue";

export default {
  name: "AccountCRUD",
  components: {
    Card
  },
  props: {
    editItem: {
      type: Object,
      default: null
    },
    deleteItem: {
      type: Object,
      default: null
    },
    newItem: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    brokers: [
      {
        name: "OANDA Cop",
        code: "oanda"
      },
      {
        name: "FXCM",
        code: "fxcm"
      },
      {
        name: "cTrader Brokers",
        code: "ctrader"
      }
      // {
      //   name: "MT4 Brokers",
      //   code: "mt4"
      // }
    ],
    agree: false,
    valid: false,
    nameLength: 25,
    isCard: false,
    nameRules: [
      v => !!v || "Name is required",
      (v => !!v && v.length <= this.nameLength) ||
        "Name must less than max characters"
    ],
    loginIdRules: [v => !!v || "Login ID is required"]
  }),
  computed: {
    ...mapGetters(["currentUser", "accounts", "strategies"]),

    formTitle() {
      if (this.editItem) {
        return "Update Account";
      } else if (this.deleteItem) {
        return "Delete Account";
      } else {
        return "Create Account";
      }
    },
    items() {
      return this.editItem || this.deleteItem || this.newItem;
    },
    itemOfCard() {
      return {
        account: this.items,
        user: this.currentUser.ext
      };
    }
  },
  created() {
    this.$store.dispatch(STRATEGY.FETCH);
  },
  methods: {
    onCreate(item) {
      this.items.userId = this.currentUser.uid;
      let isExist = this.accounts.some(
        e =>
          e.account.loginId == item.loginId && e.account.broker == item.broker
      );
      if (isExist) {
        // console.log(isExist);
        this.$store.dispatch(ERROR.PUSH, "This account is exist");
      } else {
        // console.log(isExist);
        this.$store
          .dispatch(ACCOUNT.CREATE, this.items)
          .then(() => (this.isCard = true));
      }
    },
    onEdit() {
      this.$store.dispatch(ACCOUNT.EDIT, this.items).then(() => {
        this.cancelEdit();
      });
    },
    onDelete() {
      this.$store.dispatch(ACCOUNT.DEL, this.items).then(() => {
        this.cancelDel();
      });
    },
    goTo(path) {
      this.$router.push(path);
    },
    cancelDel() {
      this.$emit("deleted", null);
    },
    cancelEdit() {
      this.$emit("edited", null);
    },
    cancelNew() {
      if (this.newItem) {
        this.$emit("closed", this.newItem);
      } else {
        this.$emit("closed", false);
      }
    }
  }
};
</script>
